// Which elements on the page are ours, and claiming each of them exactly once.

import { Widget } from "./widget"

// Stamped on the element itself rather than held in a Set in module scope: the
// stamp survives a second copy of the bundle being loaded, and a Set would not.
const CLAIMED = "mkMounted" // data-mk-mounted

// Where MessageKit is, worked out from our own <script src> and never
// hardcoded -- the same bundle runs against localhost in a system test and
// against messagekit.co in production. Captured on the first sweep, while
// document.currentScript is still valid.
let origin = null

export function originOf(script) {
  if (!origin && script && script.src) {
    try {
      origin = new URL(script.src).origin
    } catch {
      origin = null
    }
  }
  return origin
}

export function sweep(currentScript) {
  originOf(currentScript)

  // The container form first, and it is the one that matters. It works when
  // the script sits in a CMS's footer injection and the div is in a code block
  // half a page away, it survives a page builder that relocates <script> tags,
  // and it gives the customer's fallback link somewhere to live.
  document.querySelectorAll("[data-mk-signup]").forEach(mountContainer)

  // The short form: one script tag and no div.
  document.querySelectorAll("script[data-mk-form]").forEach(mountScript)
}

function mountContainer(element) {
  if (!claim(element)) return

  const token = element.getAttribute("data-mk-signup")
  if (!token) return

  new Widget(element, token, origin).start()
}

function mountScript(script) {
  if (!claim(script)) return

  const element = document.createElement("div")
  element.setAttribute("data-mk-signup", script.getAttribute("data-mk-form"))
  copyAttribute(script, element, "data-mk-style")
  copyAttribute(script, element, "data-mk-fields")
  copyAttribute(script, element, "data-mk-heading-level")

  // Exactly where the tag was pasted, which is where the customer expected the
  // form to appear.
  script.insertAdjacentElement("afterend", element)
  mountContainer(element)
}

function copyAttribute(from, to, name) {
  const value = from.getAttribute(name)
  if (value !== null) to.setAttribute(name, value)
}

function claim(element) {
  if (element.dataset[CLAIMED]) return false
  element.dataset[CLAIMED] = "1"
  return true
}
